import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { CustomerSupportService } from "src/app/services/customer-support.service";

@Injectable()
export class SetupCustomerSupportGuard implements CanActivate {
  readonly #customerSupportService = inject(CustomerSupportService);

  async canActivate(): Promise<boolean> {
    if (this.#customerSupportService.isSupported()) {
      this.#customerSupportService.enable();
    }

    return true;
  }
}
